import { faFileContract } from '@fortawesome/free-solid-svg-icons';

/**
 * Trade Recap walkthrough.
 *
 * The TradeRecap component is shared between Cargo (solids) and Bunkers
 * (fuels) - the form structure differs. We start the tour at
 * ``/trade-recap/new?type=Sale`` which defaults to ``commodityType='solids'``
 * (no location.state passed) and walk the SOLIDS section layout. The
 * top-level chrome (header, back button, stepper, save buttons) is identical
 * across commodities, so users can rerun the same tour from a fuels recap
 * and still recognise the page shell.
 */

const NEW_SALE_RECAP_ROUTE = '/trade-recap/new?type=Sale';

const recapTour = {
    id: 'recap',
    title: 'Trade Recap',
    description:
        'Walk through the recap form: deal details, contract & partners, commercial terms and deal makers, plus how to save a draft.',
    estimatedMinutes: 4,
    startRoute: NEW_SALE_RECAP_ROUTE,
    icon: faFileContract,
    group: 'flow',
    steps: [
        {
            target: '.trade-recap.hms-form-screen',
            title: 'Trade Recap',
            content:
                'The recap is the formal contract record for a deal. Once signed it locks in the commercial terms and drives everything downstream: deliveries, financials, invoicing, settlement.',
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '.hms-back-circle',
            title: 'Back to Trade Ops',
            content:
                'Leaving with unsaved changes prompts you to save as a draft first. Drafts appear under the Trade Recaps tab in Trade Ops Cargo or Bunkers.',
            placement: 'bottom',
        },
        {
            target: '.hms-stepper-bar',
            title: 'Section stepper',
            content:
                'Four sections for solids recaps: Deal Details, Contract & Partners, Commercial Terms, Deal Makers. Fuels recaps have a slightly different breakdown (IMT, Products, Ship Details, Summary, Funding).',
            placement: 'bottom',
        },
        {
            target: '#hms-anchor-deal-details',
            title: 'Deal Details',
            content:
                'Recap name, transaction number, recap type (Sale, Purchase, Freight) and the source bid/offer if this recap was promoted from one. The transaction number is auto-generated and unique per year.',
            placement: 'top',
        },
        {
            target: '#hms-anchor-contract-partners',
            title: 'Contract & Partners',
            content:
                'Buyer, seller and any third-party agents on the contract. Partners come from CRM. Contract reference, signing date and governing law live here too.',
            placement: 'top',
        },
        {
            target: '#hms-anchor-commercial-terms',
            title: 'Commercial Terms',
            content:
                'Quantity, price, currency, payment terms, Incoterms, delivery window. This section is the heart of the recap and drives invoice values downstream.',
            placement: 'top',
        },
        {
            target: '#hms-anchor-deal-makers',
            title: 'Deal Makers & Comments',
            content:
                'Who originated, traded and approved the deal - tracked for commission attribution. Comments capture anything the structured fields cannot, e.g. side letters or hedge notes.',
            placement: 'top',
        },
        {
            target: '.hms-header-actions .hms-btn-secondary',
            title: 'Save Draft',
            content:
                'Persists the recap. There is no separate "Save & Submit" - drafts are valid records; advancing to delivery happens later from the recap row in Trade Ops.',
            placement: 'bottom',
        },
        {
            target: '.trade-recap.hms-form-screen',
            title: 'You are good to go',
            content:
                'That is the recap flow. From here you create deliveries that fulfil the recap, and the financials module picks up settlement automatically. Re-run this tour any time from Hamster Training.',
            placement: 'center',
            disableBeacon: true,
            isLast: true,
        },
    ],
};

export default recapTour;
